export default __webpack_public_path__ + "static/media/project-information-icon.50046303.svg";